$(document).ready(function(){

    function formatColor (state) {
        if (!state.id) { return state.text; }
        var colour = $(state.element).data("hex");
        var $state = $(
            '<span style="background-color: ' + colour + '" class="color-label"></span><span>' + state.text + '</span>'
        );
        return $state;
    };
    
    function formatText (state) {
        if (!state.id) { return state.text; }
        var fontFamily = $(state.element).data("font-family");
        var fontStyle = ($(state.element).data("font-style") ? $(state.element).data("font-style") : 'normal');
        var fontWeight = ($(state.element).data("font-weight") ? $(state.element).data("font-weight") : 'normal');
        var $state = $(
            '<span style="font-family: \'' + fontFamily + '\', serif;font-weight: ' + fontWeight + ';font-style:' + fontStyle + ';font-size:20px;">' + state.text + '</span>'
        );
        return $state;
    };

    function select2AddClass(element) {
        element.each(function(){

            if($(this).hasClass('select2-hidden-accessible')) {
                $(this).removeClass('select2-hidden-accessible');
            }

            var _class  = $(this).attr('class');
            var _dclass = $(this).attr('dropdown-class');

            $(this).select2({
                containerCssClass: _class,
                dropdownCssClass: _dclass,
                minimumResultsForSearch: 10,
            });
        });
    }

    select2AddClass($('.form__input--select2'));

    function select2AddColour(element) {
        element.each(function(){

            if($(this).hasClass('select2-hidden-accessible')) {
                $(this).removeClass('select2-hidden-accessible');
            }

            var _class1  = $(this).attr('class');
            var _dclass1 = $(this).attr('dropdown-class');

            $(this).select2({
                containerCssClass: _class1,
                dropdownCssClass: _dclass1,
                minimumResultsForSearch: 10,
                templateResult: formatColor,
                templateSelection: formatColor
            });
        });
    }
    select2AddColour($('.form__input--select2--colours'));
    
    function select2AddText(element) {
        element.each(function(){

            if($(this).hasClass('select2-hidden-accessible')) {
                $(this).removeClass('select2-hidden-accessible');
            }

            var _class1  = $(this).attr('class');
            var _dclass1 = $(this).attr('dropdown-class');

            $(this).select2({
                containerCssClass: _class1,
                dropdownCssClass: _dclass1,
                minimumResultsForSearch: 10,
                templateResult: formatText,
                templateSelection: formatText
            });
        });
    }
    select2AddText($('.form__input--select2--text'));
});
